import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';
import { brandListColumns } from '@/modules/products/brand/brand-list/brand-list.column';
import { useBrandList } from '@/modules/products/brand/brand-list/brand-list.hook';
import { ProductSectionFilters } from '@/modules/products/product-section-filters.component';

export const BrandList = () => {
    const { data, isLoading, isError, error, isFetching, handleCreateBrand } =
        useBrandList();

    return (
        <SectionContainer isError={isError} isLoading={isLoading} error={error}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb
                            items={[
                                { label: 'Products', href: Route.PRODUCTS },
                                { label: 'Brands' },
                            ]}
                        />
                        <SectionTitle>Brand List</SectionTitle>
                    </div>
                    <Button onClick={handleCreateBrand} type={'button'}>
                        Create New Brand
                    </Button>
                </div>
                <ProductSectionFilters />
                <SectionDataTable
                    columns={brandListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

BrandList.displayName = 'BrandList';
